import React from 'react';
import { Button as AMButton } from 'antd-mobile';
import Popover from '@/components/Popover';
import { ActionElementType, ActionButtonRenderContext } from './types';

/**
 * antd-mobile的Button颜色映射
 * 后续扩展修改此函数
 * @param {string} amType
 * @return {*}
 */
const mapAMTypeToColor = function (amType: string) {
  switch (amType) {
    case 'primary':
      return 'primary';
    case 'danger':
      return 'danger';
    case 'success':
      return 'success';
    case 'warning':
      return 'warning';
    default:
      return 'default';
  }
};

/**
 * a标签类型的按钮
 * @param {ActionButtonRenderContext} ctx
 * @return {*}
 */
const renderAnchor = function (ctx: ActionButtonRenderContext) {
  const baseStyle = ctx.style || {};
  const disableStyle = !!ctx.disabled
    ? {
        pointerEvents: 'none',
        cursor: 'not-allowed',
        color: baseStyle.color != null ? baseStyle.color : '#999'
      }
    : {};
  const mergedStyle = {
    ...baseStyle,
    ...disableStyle
  } as React.CSSProperties;
  return (
    <a
      ref={function (el) {
        ctx.btnRef.current = el as any;
      }}
      className={ctx.className}
      style={mergedStyle}
      href={ctx.href}
      target={ctx.target}
      onClick={ctx.handleClick}
    >
      {ctx.loading ? '加载中…' : ctx.children}
    </a>
  );
};

/**
 * antd-mobile的Button类型的按钮
 * @param {ActionButtonRenderContext} ctx
 * @return {*}
 */
const renderAMButton = function (ctx: ActionButtonRenderContext) {
  const color = mapAMTypeToColor(ctx.amType);

  // 构造业务按钮样式
  const baseStyle: React.CSSProperties = {
    ...(ctx.style || {})
  };

  if (color === 'primary') {
    baseStyle.backgroundColor = '#3068e7';
    baseStyle.borderColor = '#3068e7';
    baseStyle.color = '#fff';
  }

  if (color === 'default') {
    baseStyle.color = '#3C6EF0';
    baseStyle.borderColor = '#3C6EF0';
  }

  return (
    <AMButton
      ref={function (el) {
        ctx.btnRef.current = el as unknown as any;
      }}
      color={color as any}
      fill={ctx.amFill as any}
      size={ctx.amSize as any}
      block={!!ctx.amBlock}
      className={ctx.className}
      style={baseStyle}
      loading={ctx.loading}
      disabled={ctx.disabled}
      onClick={ctx.handleClick}
      data-testid={ctx['data-testid']}
    >
      {ctx.children}
    </AMButton>
  );
};

/**
 * Popover包裹的a标签
 * @param {ActionButtonRenderContext} ctx
 * @return {*}
 */
const renderWithPopover = function (ctx: ActionButtonRenderContext) {
  const inner = renderAnchor(ctx);
  const p = ctx.popover || {};
  return (
    <Popover
      content={p.content}
      actions={p.actions}
      placement={p.placement}
      trigger={p.trigger || 'click'}
      visible={p.visible}
      onVisibleChange={p.onVisibleChange}
      getContainer={p.getContainer}
      destroyOnHide={p.destroyOnHide}
      stopPropagation={p.stopPropagation}
      className={p.className}
      style={p.style}
    >
      {inner as any}
    </Popover>
  );
};

/**
 * 按钮元素类型与渲染函数的映射
 */
const elementFactories: {
  [k in ActionElementType]: (
    ctx: ActionButtonRenderContext
  ) => React.ReactElement;
} = {
  [ActionElementType.button]: renderAMButton,
  [ActionElementType.a]: renderAnchor,
  [ActionElementType.withPopover]: renderWithPopover
};

/**
 * 根据按钮类型构建按钮元素
 * @param {ActionElementType} type
 * @param {ActionButtonRenderContext} ctx
 * @return {*}
 */
export const buildElement = function (
  type: ActionElementType,
  ctx: ActionButtonRenderContext
) {
  const factory =
    elementFactories[type] || elementFactories[ActionElementType.button];
  return factory(ctx);
};
